// src/components/Register.jsx

import React, { useState } from 'react';
import { Box, Button, Container, TextField, Typography, Avatar, Link as MuiLink } from '@mui/material';
import { useDispatch } from 'react-redux';
import { register } from '../../redux/authSlice'; // Import register action creator
import { Link as RouterLink, useNavigate } from 'react-router-dom'; // Import RouterLink and useNavigate
import logo from '../../assets/logo.png'; // Adjust path based on your actual file structure

const Register = () => {
  const [formData, setFormData] = useState({ username: '', email: '', password: '' });
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Initialize navigate hook from react-router-dom

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = () => {
    // Store user data in localStorage for demo purposes
    localStorage.setItem('userData', JSON.stringify(formData));
    dispatch(register(formData)); // Dispatch register action with form data
    // Redirect or handle success register flow
    navigate('/login'); // Redirect to login page after successful registration
  };

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', border: '1px solid #ccc', borderRadius: '8px', p: 3 }}>
        <Avatar alt="Logo" src={logo} sx={{ width: 64, height: 64, mb: 2 }} />
        <Typography variant="h5" gutterBottom>
          Register
        </Typography>
        <Box component="form" noValidate sx={{ mt: 1, width: '100%' }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="username"
            label="Username"
            name="username"
            autoFocus
            value={formData.username}
            onChange={handleInputChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            value={formData.email}
            onChange={handleInputChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            autoComplete="new-password"
            value={formData.password}
            onChange={handleInputChange}
          />
          <Button
            type="button"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 3, mb: 2 }}
            onClick={handleRegister}
          >
            Register
          </Button>
          <Typography variant="body2">
            Already have an account?{' '}
            <MuiLink component={RouterLink} to="/login">
              Login here
            </MuiLink>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default Register;
